if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      
      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }
      
      this.startAutoSlide();
      window.addEventListener('resize', debounce(()=>{
        this.onResize();
      }, 100).bind(this));
      this.fetchOkendoReviews();
    }

    changeSlide(direction) {

      this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
      this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

      if ( direction == 'next' ) {
        this.index++;
        if ( this.index >= this.length ) {
          this.index = 0;
        }
      } else if ( direction == 'prev' ) {
        this.index--;
        if ( this.index < 0 ) {
          this.index = this.length - 1;
        }
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('announcement-bar__content-nav--disabled');
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('announcement-bar__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

    startAutoSlide() {
      this.autoSlideInterval = setInterval(() => {
        this.changeSlide('next');
      }, 5000);

      this.slider.addEventListener('mouseenter', () => {
        clearInterval(this.autoSlideInterval);
      });

      this.slider.addEventListener('mouseleave', () => {
        this.startAutoSlide();
      });
    }

    onResize() {
      this.changeSlide(this.index);
    }

    fetchOkendoReviews() {
      const url = 'https://api.okendo.io/v1/stores/0f016477-4a22-4873-bebc-97dd95d8f254/review_aggregate';
      const reviewLocation = this.querySelector('.review-text');
      const reviewStoreLink = this.querySelector('.announcement-review');

      fetch(url)
      .then(response => {
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const calculatedScore = (data?.reviewAggregate.reviewRatingValuesTotal / data?.reviewAggregate.reviewCount).toFixed(1);
        reviewLocation.innerHTML = `${calculatedScore} from ${data?.reviewAggregate.reviewCount} reviews`;
      })
      .catch(error => {
        console.error('There has been a problem with your fetch operation:', error);
        reviewLocation.style.display = 'none';
      });
    }
  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}